// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutReviewPaymentsColumns-EmptyIconLabel_cls1__jbrpR","cls2":"PayoutReviewPaymentsColumns-EmptyIconLabel_cls2__-5n-A PayoutReviewPaymentsColumns-EmptyIconLabel_cls1__jbrpR"};